import { render, staticRenderFns } from "./AnimationConfig.vue?vue&type=template&id=db1123ca&scoped=true&"
import script from "./AnimationConfig.vue?vue&type=script&lang=js&"
export * from "./AnimationConfig.vue?vue&type=script&lang=js&"
import style0 from "./AnimationConfig.vue?vue&type=style&index=0&id=db1123ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1123ca",
  null
  
)

export default component.exports